var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0548 8.6605V6.69242C15.0548 4.38884 13.1866 2.52067 10.883 2.52067C8.57946 2.51059 6.70396 4.36959 6.69388 6.67409V6.69242V8.6605",
    stroke: "#6638A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3763 19.4788H7.37203C5.45253 19.4788 3.89603 17.9232 3.89603 16.0028V12.0712C3.89603 10.1508 5.45253 8.59521 7.37203 8.59521H14.3763C16.2958 8.59521 17.8523 10.1508 17.8523 12.0712V16.0028C17.8523 17.9232 16.2958 19.4788 14.3763 19.4788Z",
    stroke: "#6638A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8743 13.0192V15.0551",
    stroke: "#6638A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordimg);
export default __webpack_public_path__ + "static/media/passwordimg.5dc332b8e27c0ec8917e7c0a24abb8eb.svg";
export { ForwardRef as ReactComponent };